import { Box, Tab, Tabs } from "@mui/material";
import React from "react";

interface TabData {
  label: string;
  content: React.ReactNode;
}

interface TabsMAIQProps {
  tabs: TabData[];
  contentStyle?: React.CSSProperties | any;
  // MUI-like controlled props.
  value?: number;
  onChange?: (event: React.SyntheticEvent, newValue: number) => void;

  // Alternate controlled props used by other pages.
  activeTab?: number;
  onTabChange?: (index: number) => void;
}

const TabsMAIQ: React.FC<TabsMAIQProps> = ({
  tabs,
  contentStyle,
  value,
  onChange,
  activeTab,
  onTabChange,
}) => {
  const [internalValue, setInternalValue] = React.useState(0);

  const resolvedValue = value ?? activeTab;
  const isControlled = resolvedValue !== undefined;
  const currentValue: number = isControlled ? (resolvedValue ?? 0) : internalValue;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // MUI-like callback
    onChange?.(event, newValue);
    // Alternate callback
    onTabChange?.(newValue);

    if (!isControlled) setInternalValue(newValue);
  };

  // Ensure value is within bounds
  const safeValue = tabs.length > 0 ? Math.min(currentValue, tabs.length - 1) : 0;
  const currentTab = tabs[safeValue];

  return (
    <Box sx={{
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }}>
      {tabs.length > 0 && (
        <Tabs
          value={safeValue}
          onChange={handleChange}
          variant="fullWidth"
          sx={{
            flexShrink: 0,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          {tabs.map((tab, index) => (
            <Tab key={index} label={tab.label} />
          ))}
        </Tabs>
      )}
      <Box sx={{
        p: 0,
        mt: '-1px',
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
        ...(contentStyle || {}),
      }}>
        {currentTab ? currentTab.content : null}
      </Box>
    </Box>
  );
};

export default TabsMAIQ;
